import React from 'react';
import { toast } from 'react-toastify';
import SVG from 'react-inlinesvg';
import { checkCircleSVG, infoSVG } from '../../shared/helpers/icons';
import styles from '../../shared/styles/notifications.module.scss';
import { takeLatest, put, call, select, delay } from "redux-saga/effects";
import {
    GET_GPS_REQUEST,
    getGpsDevicesSuccess,
    getGpsDevicesFailure,
    GET_GPS_STATUSES_REQUEST,
    getGpsStatusesSuccess,
    getGpsStatusesFailure,
    GET_GPS_SUBSTATUS_REQUEST,
    getGpsSubstatusSuccess,
    getGpsSubstatusFailure,
    SUBMIT_GPS_REQUEST,
    submitGpsDevicesSuccess,
    submitGpsDevicesFailure,
    setStateGps,
    SUBMIT_GPS_STATUSES_REQUEST,
    submitGpsDevicesStatusesSuccess,
    submitGpsDevicesStatusesFailure,
    SUBMIT_GPS_BATCH_REQUEST,
    submitGpsBatchSuccess,
    submitGpsBatchFailure,
    SUBMIT_GPS_DEVICES_VALIDATE_BATCH_REQUEST,
    submitGpsDevicesValidateBatchSuccess,
    submitGpsDevicesValidateBatchFailure,
    UNLOCK_GPS_REQUEST,
    unlockGpsSuccess,
    unlockGpsFailure,
    GET_EXPORT_GPS_REQUEST,
    getExportGpsSuccess,
    getExportGpsFailure,
    UNSUBSCRIBE_REQUEST,
    unsubscribeSuccess,
    unsubscribeFailure,
    GET_HISTORY_GPS_REQUEST,
    getHistoryGpsSuccess,
    getHistoryGpsFailure,
    PATCH_GPS_DEVICES_REQUEST,
    patchGpsDevicesSuccess,
    patchGpsDevicesFailure,
    UPDATE_GPS_DEVICE_REQUEST,
    updateGpsDeviceSuccess,
    updateGpsDeviceFailure
} from "../actions/gps";
import {
    getHistoryGps,
    getGpsDevices,
    getGpsStatuses,
    postGpsDevice,
    putGpsDevice,
    postGpsStatuses,
    putGpsStatuses,
    postGpsDeviceBatch,
    getValidateBatchGpsDevices,
    disassociatesimcard,
    getExportGpsService,
    unsubscribeService,
    getGpsSubstatus,
    patchGpsDevices,
} from "../services/gps";
import { pingEventBeforeSubmitBatch } from "../../shared/sagas/events";
import { showGlobalError } from "../../app/actions/app";
import { accessTokenSelector } from "../../auth/selectors/token";
import { checkErrors } from "../helpers/gps";
const extractErrorMessage = (error) => {
    if (typeof error === 'string') return error;
    return error?.error || error?.message || error?.msg || 'Error desconocido';
  };

  const mapErrorMessage = (errorMsg) => {
    if (!errorMsg) return 'Error desconocido';
  
    if (errorMsg.includes('E11000') && errorMsg.includes('simcard')) {
      return 'Tiene una SIM duplicada';
    }
  
    if (errorMsg.toLowerCase().includes('simcard no encontrado')) {
      return 'SIM no encontrada';
    }
  
    if (errorMsg.toLowerCase().includes('gps ya existe')) {
      return 'El GPS ya está registrado';
    }
  
    return errorMsg;
  };
  
  const formatGpsBatchErrors = (response) => {
    const totalFailed = response?.gps?.failed || 0;
    const errors = response?.gps?.errors || [];
  
    if (!totalFailed || errors.length === 0) return null;
  
    const errorTypes = errors.map(err => mapErrorMessage(err.error));
    const uniqueErrors = [...new Set(errorTypes)];
  
    return {
      count: totalFailed,
      message: `${totalFailed} GPS no se ${totalFailed === 1 ? 'ha' : 'han'} creado`,
      detail: uniqueErrors.map(e => `- ${e}`).join('\n'),
    };
  };
  
  
const disassociationSimCard = function* ({payload: id}){
    try{
        const token = yield select(accessTokenSelector);
        const {data:{status}} = yield call(disassociatesimcard, id.gps_id, token);
        yield put(unlockGpsSuccess(status));
        yield put(showGlobalError(true, 200, "unlocked"));
        yield put(setStateGps({ submitSuccess: false }));
    } catch (err) {
        yield put(unlockGpsFailure(err))
        yield put(showGlobalError(true, err));
    }
}

const getGpsDevicesWorker = function* ({ payload: { filters, page } }) {
    try {
        const token = yield select(accessTokenSelector);
        const {
            data: { gps_devices, total }
        } = yield call(getGpsDevices, filters, token);


        yield put(getGpsDevicesSuccess(gps_devices, total, page));
    } catch (err) {
        yield put(getGpsDevicesFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getGpsStatusesWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);

        const {
            data: { statuses, total }
        } = yield call(getGpsStatuses, filters, token);

        yield put(getGpsStatusesSuccess(statuses, total));
    } catch (err) {
        yield put(getGpsStatusesFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getGpsSubstatusWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);

        const response = yield call(getGpsSubstatus, filters, token);

        const {
            data: { substatus, total }
        } = response;

        yield put(getGpsSubstatusSuccess(substatus, total));
    } catch (err) {
        yield put(getGpsSubstatusFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getHistoryGpsWorker = function* ({ payload }) {
    const id = payload && payload.filters && payload.filters.id;
    try {
        
        if (!id) {
            yield put(getHistoryGpsSuccess([], 0)); 
            return;
        }
        
        const token = yield select(accessTokenSelector);

        try {
            const response = yield call(getHistoryGps, id, token);
            
            const { data } = response;
            
            if (data && data.history && data.history.history) {
         
                const historyArray = data.history.history;
                const total = historyArray.length;
                
                    yield put(getHistoryGpsSuccess(historyArray, total));
            } else {
                yield put(getHistoryGpsSuccess([], 0));
            }
        } catch (apiErr) {
            throw apiErr; 
        }
    } catch (err) {
        yield put(getHistoryGpsFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const submitGpsDevicesWorker = function* ({ payload: { gps_device } }) {
    try {
        const token = yield select(accessTokenSelector);

        if (!gps_device.hasOwnProperty("_id")) {
            yield call(postGpsDevice, gps_device, token);
            toast.success(
                <div className={styles.customToastSuccess}>
                    <div className={styles.toastContent}>
                        <SVG src={checkCircleSVG} className={styles.toastIconSuccess} />
                       GPS creado con éxito
                    </div>
                </div>,
                {
                    className: styles.toast,
                    toastId: `user-created-${Date.now()}`
                }
            );
        } else {
            yield call(putGpsDevice, gps_device, token);
            toast.success(
                <div className={styles.customToastSuccess}>
                    <div className={styles.toastContent}>
                        <SVG src={checkCircleSVG} className={styles.toastIconSuccess} />
                       GPS creados con éxito
                    </div>
                </div>,
                {
                    className: styles.toast,
                    toastId: `user-created-${Date.now()}`
                }
            );
        }

        yield put(submitGpsDevicesSuccess());
        yield put(setStateGps({ submitSuccess: false }));
    } catch (err) {
        yield put(submitGpsDevicesFailure());
        yield put(showGlobalError(true, err, err.key));
    }
};

const submitGpsDevicesStatusWorker = function* ({ payload: { status } }) {
    try {
        const token = yield select(accessTokenSelector);

        if (!status._id) {
            yield call(postGpsStatuses, status, token);
            toast.success(
                <div className={styles.customToastSuccess}>
                    <div className={styles.toastContent}>
                        <SVG src={checkCircleSVG} className={styles.toastIconSuccess} />
                       GPSs creado con éxito
                    </div>
                </div>,
                {
                    className: styles.toast,
                    toastId: `user-created-${Date.now()}`
                }
            );
        } else {
            yield call(putGpsStatuses, status, token);
            toast.success(
                <div className={styles.customToastSuccess}>
                    <div className={styles.toastContent}>
                        <SVG src={checkCircleSVG} className={styles.toastIconSuccess} />
                       GPSs creados con éxito
                    </div>
                </div>,
                {
                    className: styles.toast,
                    toastId: `user-created-${Date.now()}`
                }
            );
        }

        yield put(submitGpsDevicesStatusesSuccess());
    } catch (err) {
        if (err && err.response && err.response.status && err.response.status === 409) {
            yield put(showGlobalError(true, 409, "status_already_exist"));
        } else {
            yield put(showGlobalError(true, err));
        }
        yield put(submitGpsDevicesStatusesFailure());
    }
};

const updateGpsDeviceWorker = function* ({ payload: { gpsId, updates } }) {
    try {
        const token = yield select(accessTokenSelector);
        
        // Llamar al servicio para actualizar el GPS
        const response = yield call(putGpsDevice, gpsId, updates, token);

        
        // Disparar acción de éxito
        yield put(updateGpsDeviceSuccess(response.data));
        
        // Mostrar notificación de éxito
        toast.success(
            <div className={styles.customToastSuccess}>
                <div className={styles.toastContent}>
                    <SVG src={checkCircleSVG} className={styles.toastIconSuccess} />
                   SimCard modificada
                </div>
            </div>,
            {
                className: styles.toast,
                toastId: `gps-updated-${Date.now()}`
            }
        );
        
    } catch (err) {
        // Manejar errores
        if (err.response && err.response.status === 409) {
            yield put(showGlobalError(true, 409, "gps_already_exists"));
        } else {
            yield put(showGlobalError(true, err));
        }
        yield put(updateGpsDeviceFailure(err));
    }
};


const submitGpsDevicesBatchWorker = function* ({ payload: { gps_devices } }) {
    try {
        const token = yield select(accessTokenSelector);
        let eventData;
        let responseStatus;
        let errors = [];
        let createdCount = 0;

        try {
            const response = yield call(postGpsDeviceBatch, gps_devices, token);
            eventData = response.data.event;
            responseStatus = response.status;
            
            const gpsResponse = response.data?.gps;
            if (gpsResponse) {
                createdCount = gpsResponse.created || 0;
                errors = gpsResponse.errors || [];
            }
        } catch (apiError) {
            const gpsResponse = apiError.response?.data?.gps;
            
            if (apiError.response?.status === 201 && gpsResponse?.event) {
                eventData = gpsResponse.event;
                responseStatus = 200;
                createdCount = gpsResponse.created || 0;
                errors = gpsResponse.errors || [];
            } else {
                throw apiError;
            }
        }

        yield delay(1000);

        if (eventData && eventData._id) {
            yield call(pingEventBeforeSubmitBatch, eventData._id, token);
        }

        yield put(submitGpsBatchSuccess());
        yield put(setStateGps({ submitSuccess: false }));

        // ✅ Toast de éxito si hubo creados
        if (createdCount > 0) {
            toast.success(
                <div className={styles.customToastSuccess}>
                    <div className={styles.toastContent}>
                        <SVG src={checkCircleSVG} className={styles.toastIconSuccess} />
                        {createdCount} GPS{createdCount > 1 ? 's' : ''} creados con éxito
                    </div>
                </div>,
                {
                    className: styles.toast,
                    toastId: `gps-created-${Date.now()}`
                }
            );
        }
        if (errors.length > 0) {
            const failedCount = errors.length;
            const plural = failedCount > 1 ? 'GPSs no se pudieron crear' : 'GPS no se pudo crear';
            const errorMessages = errors.map(err => {
                if (typeof err === 'string') return err;
                return err?.error || err?.message || 'Error desconocido';
            }).join('\n');
        
            toast.error(
                <div className={styles.customToastError}>
                    <div className={styles.toastContent}>
                        <SVG src={infoSVG} className={styles.toastIconError} />
                        {failedCount} {plural}
                        {/* <pre style={{ whiteSpace: 'pre-wrap', marginTop: 5 }}>
                            {errorMessages}
                        </pre> */}
                    </div>
                </div>,
                {
                    className: styles.toast,
                    autoClose: 10000,
                    closeButton: true
                }
            );
        }
        

    } catch (err) {
        yield put(submitGpsBatchFailure());

        let errorMessage = 'Error al procesar la solicitud';
        const errors = err.response?.data?.errors || [];

        if (errors.length > 0) {
            errorMessage = errors.map(err =>
                err?.error || err?.message || err?.msg || 'Error desconocido'
            ).join('\n');
        }

        toast.error(
            <div className={styles.customToastError}>
                <div className={styles.toastContent}>
                    <SVG src={infoSVG} className={styles.toastIconError} />
                    {errorMessage}
                </div>
            </div>,
            {
                className: styles.toast,
                autoClose: 10000
            }
        );

        yield put(showGlobalError(true, err, err.key));
    }
};

  

const submitGpsDevicesValidateBatchWorker = function* ({ payload: { gps_device } }) {
    try {

        const token = yield select(accessTokenSelector);

        const {
            data: { validations }
        } = yield call(getValidateBatchGpsDevices, gps_device, token);

        yield put(submitGpsDevicesValidateBatchSuccess(validations));
        yield put(setStateGps({ submitValidateBatchSuccess: false }));

    } catch (err) {
        yield put(submitGpsDevicesValidateBatchFailure());
        yield put(showGlobalError(true, err, err.key));
    }
};

const getExportGpsWorker = function* ({ payload: { filters }}) {
    try {
        const accessToken = yield select(accessTokenSelector);

        const response = yield call(getExportGpsService, filters, accessToken);

        // El API retorna directamente el archivo Excel, no un evento
        if (response.data && response.status === 200) {

            // Crear blob y descargar archivo
            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `gps_export_${new Date().toISOString().slice(0,10)}.xlsx`);
            document.body.appendChild(link);
            link.click();

            // Limpiar
            setTimeout(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }, 100);

            yield put(getExportGpsSuccess({ success: true }));
        } else {
            yield put(getExportGpsFailure());
        }
    } catch (err) {

        yield put(getExportGpsFailure());
        yield put(showGlobalError(true, err));
    }
}

const unsubscribeWorker = function* ({ payload: { gps_devices } }) {
    try {
        const accessToken = yield select(accessTokenSelector);

        const {
            data
        } = yield call(unsubscribeService, accessToken ,gps_devices);

        const result = data.result;
        
        yield delay(1000);

        yield put(unsubscribeSuccess(result));
        
        // Show message based on results with proper toast styling
        if (result.successful > 0 && result.failed > 0) {
            // Mixed results - some successful, some failed
            toast.success(
                <div className={styles.customToastSuccess}>
                    <div className={styles.toastContent}>
                        <SVG src={checkCircleSVG} className={styles.toastIconSuccess} />
                        Se dieron de baja {result.successful} GPS correctamente y {result.failed} con error
                    </div>
                </div>,
                {
                    className: styles.toast,
                    toastId: 'gps-unsubscribe-mixed'
                }
            );
        } else if (result.successful > 0) {
            // All successful
            toast.success(
                <div className={styles.customToastSuccess}>
                    <div className={styles.toastContent}>
                        <SVG src={checkCircleSVG} className={styles.toastIconSuccess} />
                        Se dieron de baja {result.successful} GPS correctamente
                    </div>
                </div>,
                {
                    className: styles.toast,
                    toastId: 'gps-unsubscribe-success'
                }
            );
        } else if (result.failed > 0) {
            // All failed
            toast.error(
                <div className={styles.customToastError}>
                    <div className={styles.toastContent}>
                        <SVG src={infoSVG} className={styles.toastIconError} />
                        No se pudieron dar de baja {result.failed} GPS
                    </div>
                </div>,
                {
                    className: styles.toast,
                    toastId: 'gps-unsubscribe-failed'
                }
            );
        }

    } catch (err) {

        yield put(unsubscribeFailure());
        yield put(showGlobalError(true, err));
    }
}

const patchGpsDevicesBatchWorker = function* ({ payload: { gpsDevicesArray } }) {
    try {
      const token = yield select(accessTokenSelector);
      yield call(patchGpsDevices, gpsDevicesArray, token); 
  
      yield put(patchGpsDevicesSuccess());
      toast.success(
            <div className={styles.customToastSuccess}>
                <div className={styles.toastContent}>
                    <SVG src={checkCircleSVG} className={styles.toastIconSuccess} />
                   GPSs actualizados con éxito
                </div>
            </div>,
            {
                className: styles.toast,
                toastId: `user-created-${Date.now()}`
            }
        );
      yield put(setStateGps({ submitSuccess: false }));
    } catch (err) {
      console.error('patchGpsDevices error:', err);
      yield put(patchGpsDevicesFailure());
      yield put(showGlobalError(true, err, err.key));
    }
  };


export default [
    takeLatest(GET_GPS_REQUEST, getGpsDevicesWorker),
    takeLatest(GET_GPS_STATUSES_REQUEST, getGpsStatusesWorker),
    takeLatest(GET_GPS_SUBSTATUS_REQUEST, getGpsSubstatusWorker),
    takeLatest(SUBMIT_GPS_REQUEST, submitGpsDevicesWorker),
    takeLatest(SUBMIT_GPS_STATUSES_REQUEST, submitGpsDevicesStatusWorker),
    takeLatest(SUBMIT_GPS_BATCH_REQUEST, submitGpsDevicesBatchWorker),
    takeLatest(SUBMIT_GPS_DEVICES_VALIDATE_BATCH_REQUEST, submitGpsDevicesValidateBatchWorker),
    takeLatest(UNLOCK_GPS_REQUEST, disassociationSimCard),
    takeLatest(GET_EXPORT_GPS_REQUEST, getExportGpsWorker),
    takeLatest(UNSUBSCRIBE_REQUEST, unsubscribeWorker),
    takeLatest(GET_HISTORY_GPS_REQUEST, getHistoryGpsWorker),
    takeLatest(PATCH_GPS_DEVICES_REQUEST, patchGpsDevicesBatchWorker),
    takeLatest(UPDATE_GPS_DEVICE_REQUEST, updateGpsDeviceWorker)
];
